<div class="template-menu">
  <div class="template-menu-header">
    <h3 data-test-id="template-menu-title">Templates</h3>
    <mat-icon class="close-icon" data-test-id="template-menu-close" (click)="closeMenu()"> close </mat-icon>
  </div>
  <div class="template-tabs">
    <button
      class="thin-button"
      data-test-id="template-menu-my-templates"
      [ngClass]="tabForDisplay === 'adminTemplates' ? 'active' : ''"
      (click)="openTab('adminTemplates')"
    >
      My templates
    </button>
    <button
      class="thin-button"
      data-test-id="template-menu-all-templates"
      [ngClass]="tabForDisplay === 'allAdminTemplates' ? 'active' : ''"
      (click)="openTab('allAdminTemplates')"
    >
      All templates
    </button>
  </div>
  <div class="search-input">
    <mat-icon class="search-input-icon">search</mat-icon>
    <input
      class="search-input-input"
      type="text"
      placeholder="Search templates..."
      data-test-id="template-menu-search"
      [(ngModel)]="searchTerm"
      (keyup)="filterTemplates($event.target)"
    />
  </div>
  <ul class="template-list">
    @for (template of filteredTemplates; track template) {
      <li
        class="template-list-item"
        data-test-id="template-menu-item"
        [ngClass]="template.templateId === solicitationService.activeTemplate?.templateId ? 'active-template' : ''"
        (click)="openTemplate(template)"
      >
        <div class="template-info">
          <span class="template-title" data-test-id="template-menu-template-title">{{ template.title }}</span>
          <span
            title="{{ template.description }}"
            class="template-description"
            data-test-id="template-menu-template-description"
            >{{ template.description }}</span
          >
        </div>
        <div class="action-items">
          <button mat-icon-button [disabled]="template.editDisabled" (click)="emitOpenEditTemplateForm(template)">
            <mat-icon
              matTooltip="Only email template admins can edit master templates"
              data-test-id="template-menu-template-edit"
              [matTooltipDisabled]="!template.editDisabled"
            >
              edit
            </mat-icon>
          </button>
          <button mat-icon-button [disabled]="template.cloneDisabled" (click)="duplicateTemplate(template)">
            <mat-icon
              matTooltip="Only master templates can be cloned"
              data-test-id="template-menu-template-clone"
              [matTooltipDisabled]="!template.cloneDisabled"
            >
              file_copy
            </mat-icon>
          </button>
        </div>
      </li>
    }
  </ul>
  <button
    class="button button--danger"
    matTooltip="Please use a MASTER template instead if at all possible"
    data-test-id="template-menu-create"
    (click)="emitOpenNewTemplateForm()"
  >
    Create new template
  </button>
</div>
